/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
*/

import { Injectable } from '@angular/core';

/**
 * Angular service that functions as a metrics-service, using GTM under the hood.
 */
@Injectable()
export class AnalyticsService {
  /**
   * NOTE: The registration of the GTM API is located in the `index.html` file.
   * It looks like this :
   *
   *  <!-- Google Tag Manager -->
   *  <script>
   *    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
   *        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
   *      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
   *      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
   *    })(window,document,'script','dataLayer','GTM-56HJZ6H'); <-- Very important, since this is the prod & staging
   *                                  GTM Container id. For testing locally on our
   *                                  ***dev environments*** => GTM-PPV326M
   *  </script>
   *  <!-- End Google Tag Manager -->
   */

  /**
   * dataLayer for our GTM.
   */
  private dataLayer : any = (window.dataLayer || new Array<any>());

  /**
   * Push an analytics event.
   *
   * @param eventObject Event to be posted.
   */
  pushEvent(eventObject : any) : void {
    if (!eventObject.event) {
      console.error('eventObject must contain an \'event\' property!, did not send event to GTM.  Use'
        + ' pushData() to set session data.');
    } else {
      this.dataLayer.push(eventObject);
    }
  }

  /**
   * Update session data for analytics.
   *
   * @param dataObject Object containing data to store as analytics session data.
   */
  pushData(dataObject : any) : void {
    if (dataObject.event) {
      console.error('dataObject must not contain an \'event\' property!, did not update session data.  Use'
        + ' pushEvent() to fire an event.');
    } else {
      this.dataLayer.push(dataObject);
    }
  }

  /**
   * push analytics based on the gtag method pattern.
   *
   * For example: rather than using gtag('event', 'sign_up'), we use AnalyticsService.push('event', 'sign_up').
   */
  push() : void {
    // eslint-disable-next-line prefer-rest-params
    this.dataLayer.push(arguments);
  }
}
